<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-chevron-triple-left"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingExpenseCategory"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="expenseCategory.name"
                        >
                          <v-text-field
                            v-model="expenseCategory.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.expenseCategory.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const expenseCategoriesRespository = repositoryFactory.get('expenseCategories')

  export default {
    inject: ['theme'],
    name: 'ExpenseCategoryCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      expenseCategory: {

      },
      currencies: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingExpenseCategory: false,
      loadingSave: false,
      formAction: null,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-expenseCategory') : this.$t('modify-expenseCategory')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingExpenseCategory = true
        var id = this.$route.params.id
        expenseCategoriesRespository.getById(id).then(response => {
          self.loadingExpenseCategory = false
          self.expenseCategory = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingExpenseCategory = false
          alert(err)
        })
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.expenseCategory,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          expenseCategoriesRespository.updateExpenseCategory(data, this.expenseCategory.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        } else {
          expenseCategoriesRespository.addExpenseCategory(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'expenseCategories' })
      },
    },
  }
</script>
